/**
 * MOST Web Framework 2.0 Codename Blueshift
 * Copyright (c) 2017, THEMOST LP All rights reserved
 *
 * Use of this source code is governed by an BSD-3-Clause license that can be
 * found in the LICENSE file at https://themost.io/license
 */
var _document = require('./document');

module.exports.XDocument = _document.XDocument;
module.exports.XNode = _document.XNode;
module.exports.XNamespace = _document.XNamespace;
module.exports.XSerializer = _document.XSerializer;
module.exports.XNodeType = _document.XNodeType;

